import { SxProps } from '@mui/material';
import { FC } from 'react';
import HeaderBar from '@components/HeaderBar';
import HeaderBarLogo from '@components/HeaderBarLogo';

interface VogelActuHeaderProps {
    subtitle: string;
    titleContainerSx?: SxProps;
}

const VogelActuHeader: FC<VogelActuHeaderProps> = ({ subtitle, titleContainerSx }) => (
    <HeaderBar
        subtitle={subtitle}
        title={
            <HeaderBarLogo
                alt="Vogel Actu"
                opticalOffsetX={11}
                src="/assets/vogel-actu-dark.svg"
                width={160}
            />
        }
        titleContainerSx={titleContainerSx}
    />
);

export default VogelActuHeader;
